{
  "generic": "Произошла непредвиденная ошибка",
  "network": "Ошибка сети. Проверьте соединение.",
  "notFound": "Страница не найдена",
  "forbidden": "Доступ запрещён",
  "tryAgain": "Попробовать снова"
}
